export default class PhsApplyRq {
  paccYn: boolean;
  pstYn: boolean;

  constructor(vo: PhsApplyRq) {
    this.paccYn = vo.paccYn;
    this.pstYn = vo.pstYn;
  }
}
